import { Translator } from './translator';

export abstract class TranslatorService implements Translator {
  abstract translate(key: string, args?: { [key: string]: any }): string;
  abstract has(key: string): boolean;
}
